import { connect } from "react-redux";
import LazyLoadObserver from "../../../presentational/common/LazyLoadObserver";
import {
  getItemBlocks,
  getDisplayableItemCount
} from "../../../../state/selectors";
import { getSavedItemsAroundIndex } from "../../../../state/actions";

const mapStateToProps = state => ({
  itemBlocks: getItemBlocks(state),
  totalItems: getDisplayableItemCount(state)
});

const mapDispatchToProps = dispatch => ({
  onIntersection: (
    [{ isIntersecting, intersectionRect, boundingClientRect }],
    _,
    { start, end, bufferedStart, bufferedEnd },
    unobserve
  ) => {
    if (isIntersecting) {
      unobserve();

      const percentageObserver =
        (Math.abs(Math.min(0, boundingClientRect.top)) +
          intersectionRect.height / 2) /
        boundingClientRect.height;

      const bufferedOffset = Math.floor(
        percentageObserver * (bufferedEnd - bufferedStart + 1)
      );

      const index = Math.max(
        start,
        Math.min(bufferedStart + bufferedOffset, end)
      );

      dispatch(getSavedItemsAroundIndex({ index }));
    }
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(LazyLoadObserver);
